import React, { FC } from 'react'
import * as app from '../styles/App.styled'
import * as projects from '../styles/Projects.styled'
import cegs from '../assets/cegs.svg'
import cat from '../assets/cat.svg'
import SlideInMotion, {
  SlideInDirection,
} from './SlideInMotion'

export const Projects:FC = () => {
  const { left, right } = SlideInDirection

  return (
    <app.StyledSection>
      <app.StyledCardSmallDarkBlack>
        <projects.StyledA
          href='https://www.createapplicationtemplate.com/'
          target='_blank'
          rel='noreferrer'
        >
          <projects.StyledCat src={cat} alt='cat'/>
          <projects.StyledTextTitleCat>Create Application Template (CAT)</projects.StyledTextTitleCat>
          <div>provides a configured application template</div>
        </projects.StyledA>
      </app.StyledCardSmallDarkBlack>
      <app.StyledCardLargeLightBlack>
        <projects.StyledA
          href='https://www.npmjs.com/package/create-epic-graphql-server'
          target='_blank'
          rel='noreferrer'
        >
          <SlideInMotion direction={left}>
            <projects.StyledTextWrapper>
              <div>Create Epic GraphQL Server (CEGS)</div>
              <div>offers a ready-to-use GraphQL server</div>
            </projects.StyledTextWrapper>
          </SlideInMotion>
          <SlideInMotion direction={right}>
            <projects.StyledCcrate src={cegs}/>
          </SlideInMotion>
        </projects.StyledA>
      </app.StyledCardLargeLightBlack>
    </app.StyledSection>
  )
}
